// extracted by mini-css-extract-plugin
module.exports = {"logo":"HtcLogo_logo__19s-9"};